/*
 * pack-underline: inside the PDP highlight bullets (.a-pdp__highlights), underline any multipack
 * phrase ("12-pack", "50 pack", "24 pairs", "Box of 100", ...) in the brand mustard, matching the
 * title treatment. Walks text nodes only, so it never disturbs the <strong> emphasis already there
 * (a pack phrase inside a bold segment ends up bold AND underlined). Pure enhancement, no-ops when
 * no pack phrase is present.
 */
(function () {
  'use strict';
  // number-led ("12-pack", "24 pairs", "6 pk") OR container-led ("Box of 100", "Case of 2000")
  var RE = /\b\d{1,4}\s*[-‐‑]?\s*(?:pack|pairs?|pk)\b|\b(?:box|case|pack|bag)\s+of\s+\d{1,4}\b/gi;

  function wrapTextNode(t) {
    var s = t.nodeValue;
    RE.lastIndex = 0;
    if (!RE.test(s)) return;
    RE.lastIndex = 0;
    var frag = document.createDocumentFragment(), last = 0, m;
    while ((m = RE.exec(s))) {
      if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
      var u = document.createElement('u');
      u.className = 'a-pdp__packu';
      u.textContent = m[0];
      frag.appendChild(u);
      last = m.index + m[0].length;
    }
    if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
    t.parentNode.replaceChild(frag, t);
  }

  function process(root) {
    // collect text nodes first (mutating during walk invalidates the walker)
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) {
      // skip nodes already inside our own <u> (idempotent re-runs)
      if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('a-pdp__packu')) continue;
      nodes.push(n);
    }
    nodes.forEach(wrapTextNode);
  }

  function init() {
    var lists = document.querySelectorAll('.a-pdp__highlights');
    for (var i = 0; i < lists.length; i++) process(lists[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
